module.exports = __webpack_public_path__ + "img/1.930b54df.jpg";